import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Form from './Form';

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      reiks.tec.br {' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}


export default function FormControl() {
  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar
        position="absolute"
        color="default"
        elevation={0}
        sx={{
          position: 'relative',
          float: 'center',
          borderBottom: (t) => `1px solid ${t.palette.divider}`,
          backgroundColor: '#FFF',
        }}
      >
        <Toolbar className="nav-bar">
          <Typography variant="h6" color="inherit" noWrap>
            Prediction Model Execution - Myocardium Revascularization 
          </Typography>
        </Toolbar>
      </AppBar>
      <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
        <Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
            <React.Fragment>
              <Form/>
            </React.Fragment>
        </Paper>
        <Copyright />
      </Container>
    </React.Fragment>
  );
}